import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import CustomerItem from "../../../../../../components/calculator/Wizard/CustomerItem";
import InputTextSimple from "../../../../../../components/common/InputText/InputTextSimple";
import HttpHelper from "../../../../../../helpers/Http/HttpHelper";
import { API_ROUTES } from "../../../../../../constants/API_ROUTES";
import useAuth from "../../../../../../hooks/useAuth";
import { toast } from "react-toastify";
import { ROUTES } from "../../../../../../constants/Routes";
import Spinner from "../../../../../../components/common/Splnner/Spinner";
import ErrorLabel from "../../../../../../components/common/label/ErrorLabel";
import SpinnerV2 from "../../../../../../components/common/Splnner/SpinnerV2";

const CustomerList = forwardRef(({ selectCustomer, selectedCustomer }, ref) => {
  const [sipinnerDisplay, setSipinnerDisplay] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [customers, setCustomers] = useState([]);
  const { getAuth, clearAuth } = useAuth();

  useImperativeHandle(ref, () => ({
    fetchCustomers: fetchCustomers,
  }));

  const fetchCustomers = () => {
    setSipinnerDisplay(true);
    HttpHelper.GetRequest({
      route: API_ROUTES.CUSTOMER_LIST,
      token: getAuth()?.bearerToken,
      searchQuery: searchText,
    })
      .then((data) => {
        if (data.status === 200) {
          const customers = data?.data?.customers;
          setCustomers(customers);
          setSipinnerDisplay(false);
        } else if (data.status === 401) {
          clearAuth();
          setSipinnerDisplay(false);
          navigator(ROUTES.AUTH);
        } else if (data.status === 500) {
          setSipinnerDisplay(false);
          toast.error("Error, Server Error !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.error("Unknown server error !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Unknown server error !", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  useEffect(() => {
    fetchCustomers();
  }, [searchText]);

  return (
    <div className="">
      <div className="w-full px-2 pt-2 mb-4">
        <InputTextSimple
          placeholder={`Ügyfél keresése`}
          variant="bold"
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
        />
      </div>
      <SpinnerV2 spinnerVisible={sipinnerDisplay}>
        <div className="mt-5 ps-2 pe-4 max-h-[22rem]  overflow-y-auto">
          <ul className="">
            {customers?.map((item, index) => (
              <li key={`${item}-${index}`}>
                <CustomerItem
                  name={"customer"}
                  id={`customer-${index}`}
                  value={`${item?.id}`}
                  selectedOption={selectedCustomer}
                  onChange={(e) => selectCustomer(e.target.value)}
                  label={`${item?.keresztnev} ${item?.vezeteknev}`}
                />
              </li>
            ))}
          </ul>
        </div>
      </SpinnerV2>
    </div>
  );
});

export default CustomerList;
